import {
  Component,
  Directive,
  OnInit,
  Optional,
  ViewEncapsulation,
  NgModule,
  ModuleWithProviders
} from '@angular/core';
import { MdlStructureError } from '../common/mdl-error';



export class MdlCardComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-card',
  host: {
    '[class.mdl-card]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class MdlCardChildStructure implements OnInit {

  constructor(private mdlCardComponent: MdlCardComponent, private childComponentName: string) {
  }

  public ngOnInit() {
    if (this.mdlCardComponent === null) {
      throw new MdlStructureError(this.childComponentName, 'mdl-card');
    }
  }
}


export class MdlCardTitleComponent extends MdlCardChildStructure {

  constructor( mdlCardComponent: MdlCardComponent) {
    super(mdlCardComponent, 'mdl-card-title');
  }

  public ngOnInit() { super.ngOnInit(); }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-card-title',
  host: {
    '[class.mdl-card__title]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlCardComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlCardSupportingTextComponent extends MdlCardChildStructure {

  constructor( mdlCardComponent: MdlCardComponent) {
    super(mdlCardComponent, 'mdl-card-supporting-text');
  }

  public ngOnInit() { super.ngOnInit(); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-card-supporting-text',
  host: {
    '[class.mdl-card__supporting-text]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlCardComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlCardMediaComponent extends MdlCardChildStructure {

  constructor( mdlCardComponent: MdlCardComponent) {
    super(mdlCardComponent, 'mdl-card-media');
  }

  public ngOnInit() { super.ngOnInit(); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-card-media',
  host: {
    '[class.mdl-card__media]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlCardComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlCardActionsComponent extends MdlCardChildStructure {

  constructor( mdlCardComponent: MdlCardComponent) {
    super(mdlCardComponent, 'mdl-card-actions');
  }

  public ngOnInit() { super.ngOnInit(); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-card-actions',
  host: {
    '[class.mdl-card__actions]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlCardComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlCardMenuComponent extends MdlCardChildStructure {

  constructor( mdlCardComponent: MdlCardComponent) {
    super(mdlCardComponent, 'mdl-card-menu');
  }

  public ngOnInit() { super.ngOnInit(); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-card-menu',
  host: {
    '[class.mdl-card__menu]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdlCardComponent, decorators: [{ type: Optional }, ]},
];
}


export class MdlCardTitleTextDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdl-card-title-text]',
  host: {
    '[class.mdl-card__title-text]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class MdlCardBorderDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdl-card-border]',
  host: {
    '[class.mdl-card--border]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class MdlCardExpandDirective {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdl-card-expand]',
  host: {
    '[class.mdl-card--expand]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


const MDL_CARD_DIRECTIVES = [
  MdlCardComponent,
  MdlCardTitleComponent,
  MdlCardMediaComponent,
  MdlCardSupportingTextComponent,
  MdlCardActionsComponent,
  MdlCardMenuComponent,
  MdlCardTitleTextDirective,
  MdlCardBorderDirective,
  MdlCardExpandDirective
];


export class MdlCardModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: MdlCardModule,
      providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [],
  exports: MDL_CARD_DIRECTIVES,
  declarations: MDL_CARD_DIRECTIVES,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
